import { gql } from '@apollo/client';

const GET_ROLES = gql`
  query Getroles {
    getRoles
  }
`;

export { GET_ROLES };
